var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-chart"},[_c('div',{ref:"chart",staticClass:"chart"}),_c('loading',{attrs:{"loading":_vm.loading,"color":_vm.lines[0].color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }